<template>
  <transition name="fade">
    <div class="vote-view-container">
      <div :class="[ displayPromptOnly ? 'prompt-only' : 'full', 'vote-view-container-content']">
        <transition name="fade-slow">
          <div class="prompt-container" v-show="displayPromptContainer">
            {{ voteInfo.promptText }}
          </div>
        </transition>
        <transition name="pop-from-top">
          <div style="display: block;" v-show="displayMessageContainer">
            <div class="message-container" >
              <div :style="{ opacity: submittingVote ? 1 : 0 }" class="loading-dots-container">
                <Spinner color="teal" />
              </div>
              <div :style="{ opacity: votedForA || votedForB ? 1 : 0 }" class="vote-submitted-message-container">
                <div>
                  Your vote has been counted!
                </div>
                <div>
                  Waiting for other players to vote...
                </div>
              </div>
              <div :style="{ opacity: !submittingVote && !votedForA && !votedForB ? 1 : 0 }" class="vote-message-container">
                <div v-if="voteInfo.canPlayerVote">
                  Vote by clicking on the better answer!
                </div>
                <div v-else>
                  This is your prompt, so just sit tight while the others vote!
                </div>
              </div>
            </div>
          </div>
        </transition>
        <div
          :style="{ opacity: timeRemaining.length > 0 && !displayPromptOnly && displayMessageContainer ? 1 : 0 }"
          class="vote-timer-container"
        >
          <div :class="[ 'timer-text', { 'ten-seconds-left': totalSecondsRemaining < 11 && totalSecondsRemaining >= 0, 
                        'zero-seconds-left': totalSecondsRemaining < 0 }]"
          >
            {{ timeRemaining }}
          </div>
        </div>
        <transition name="fade-slow">
          <div class="answer-container" v-show="displayAnswerContainer">
            <div class="answer-container-content">
              <transition name="pop-from-top">
                <div
                  :class="[ 'answer-button',
                            voteInfo.canPlayerVote ? '' : 'answer-button-disabled',
                            voteInfo.answers[0].replyType === 'text' ? 'answer-button-text' : 'answer-button-gif',
                            voteInfo.answers[0].replyType === 'text' && votedForA ? 'answer-button-chosen' : '',
                            voteInfo.answers[0].replyType === 'text' && votedForB ? 'answer-button-not-chosen' : '',
                            voteInfo.answers[0].replyType === 'text' && (votedForA || votedForB) ? 'answer-button-disabled' : '' ]"
                  @click="submitVoteForA"
                >
                  <div v-if="voteInfo.answers[0].replyType === 'text'">
                    {{ voteInfo.answers[0].answerText }}
                  </div>
                  <video
                    v-if="voteInfo.answers[0].replyType === 'gif' && !isSafari"
                    :class="[ 'answer-img',
                              voteInfo.canPlayerVote ? '' : 'answer-img-disabled',
                              voteInfo.answers[0].replyType === 'gif' && votedForA ? 'answer-img-chosen' : '',
                              voteInfo.answers[0].replyType === 'gif' && votedForB ? 'answer-img-not-chosen' : '',
                              voteInfo.answers[0].replyType === 'gif' && (votedForA || votedForB) ? 'answer-img-disabled' : '' ]"
                    :src="voteInfo.answers[0].answerHighResMp4Url"
                    muted
                    autoplay
                    loop
                    playsinline
                  >
                  </video>
                  <img
                    v-if="voteInfo.answers[0].replyType === 'gif' && isSafari"
                    :class="[ 'answer-img',
                              'lazyload',
                              voteInfo.canPlayerVote ? '' : 'answer-img-disabled',
                              voteInfo.answers[0].replyType === 'gif' && votedForA ? 'answer-img-chosen' : '',
                              voteInfo.answers[0].replyType === 'gif' && votedForB ? 'answer-img-not-chosen' : '',
                              voteInfo.answers[0].replyType === 'gif' && (votedForA || votedForB) ? 'answer-img-disabled' : '' ]"
                    :src="voteInfo.answers[0].answerLowResGifUrl"
                    :data-src="voteInfo.answers[0].answerHighResGifUrl"
                  />
                </div>
              </transition>
              <transition name="pop-from-top">
                <div
                  :class="[ 'answer-button',
                            voteInfo.canPlayerVote ? '' : 'answer-button-disabled',
                            voteInfo.answers[1].replyType === 'text' ? 'answer-button-text' : 'answer-button-gif',
                            voteInfo.answers[1].replyType === 'text' && votedForB ? 'answer-button-chosen' : '',
                            voteInfo.answers[1].replyType === 'text' && votedForA ? 'answer-button-not-chosen' : '',
                            voteInfo.answers[1].replyType === 'text' && (votedForA || votedForB) ? 'answer-button-disabled' : '' ]"
                  @click="submitVoteForB"
                >
                  <div v-if="voteInfo.answers[1].replyType === 'text'">
                    {{ voteInfo.answers[1].answerText }}
                  </div>
                  <video
                    v-if="voteInfo.answers[1].replyType === 'gif' && !isSafari"
                    :class="[ 'answer-img',
                              voteInfo.canPlayerVote ? '' : 'answer-img-disabled',
                              voteInfo.answers[1].replyType === 'gif' && votedForB ? 'answer-img-chosen' : '',
                              voteInfo.answers[1].replyType === 'gif' && votedForA ? 'answer-img-not-chosen' : '',
                              voteInfo.answers[1].replyType === 'gif' && (votedForA || votedForB) ? 'answer-img-disabled' : '' ]"
                    :src="voteInfo.answers[1].answerHighResMp4Url"
                    muted
                    autoplay
                    loop
                    playsinline
                  >
                  </video>
                  <img
                    v-if="voteInfo.answers[1].replyType === 'gif' && isSafari"
                    :class="[ 'answer-img',
                              'lazyload',
                              voteInfo.canPlayerVote ? '' : 'answer-img-disabled',
                              voteInfo.answers[1].replyType === 'gif' && votedForB ? 'answer-img-chosen' : '',
                              voteInfo.answers[1].replyType === 'gif' && votedForA ? 'answer-img-not-chosen' : '',
                              voteInfo.answers[1].replyType === 'gif' && (votedForA || votedForB) ? 'answer-img-disabled' : '' ]"
                    :src="voteInfo.answers[1].answerLowResGifUrl"
                    :data-src="voteInfo.answers[1].answerHighResGifUrl"
                  />
                </div>
              </transition>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </transition>
</template>

<script>
import Vue from 'vue';
import Spinner from '@/components/utilComponents/Spinner';

export default Vue.extend({
  name: 'DemoVoteView',
  components: {
    Spinner
  },
  props: {
    voteInfo: Object,
    primaryColor: String,
    totalSecondsRemaining: Number,
    timeRemaining: String,
    isSafari: Boolean
  },
  data: () => ({
    submittingVote: false,
    votedForA: false,
    votedForB: false,
    displayPromptOnly: true,
    displayPromptContainer: false,
    displayMessageContainer: false,
    displayAnswerContainer: false
  }),
  computed: {
    auth0UserId: function () {
      return this.$auth.user.sub.replace(/\|/g, '_');
    },
    idToken: function () {
      return this.$auth.idToken;
    }
  },
  methods: {
    timeout(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    submitVoteForA () {
      if (!this.submittingVote && !this.votedForA && !this.votedForB) {
        this.votedForA = true;
        this.submittingVote = false;
        this.$emit('vote-submitted', 'A');
      }
    },
    submitVoteForB () {
      if (!this.submittingVote && !this.votedForA && !this.votedForB) {
        this.votedForB = true;
        this.submittingVote = false;
        this.$emit('vote-submitted', 'B');
      }
    }
  },
  mounted: async function() {
    this.displayPromptContainer = true;
    this.$emit('play-sound-effect', 'prompt-reveal');
    await this.timeout(3000);
    this.displayPromptOnly = false;
    await this.timeout(2000);
    this.displayMessageContainer = true;
    await this.timeout(500);
    this.displayAnswerContainer = true;
    this.$emit('play-sound-effect', 'answer-reveal');
  }
})
</script>

<style scoped lang="scss">
@import '@/styles/vote-view-styles.scss';
</style>
